var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSheet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.66667V5H6.66667V1.66667H5V5H1.66667V6.66667H5V13.3333H6.66667V6.66667H13.3333ZM13.3333 0C13.75 0 14.1667 0.166667 14.4917 0.508333C14.8333 0.833333 15 1.25 15 1.66667V13.3333C15 13.75 14.8333 14.1667 14.4917 14.4917C14.1667 14.8333 13.75 15 13.3333 15H1.66667C1.25 15 0.833333 14.8333 0.508333 14.4917C0.166667 14.1667 0 13.75 0 13.3333V1.66667C0 1.25 0.166667 0.833333 0.508333 0.508333C0.833333 0.166667 1.25 0 1.66667 0H13.3333Z",
    fill: "#27A055"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet);
export default __webpack_public_path__ + "static/media/sheet.f249057148a7bc516cddd966629139ed.svg";
export { ForwardRef as ReactComponent };